// extracted by mini-css-extract-plugin
export default {"hero":"About_hero__mwtm4","founderImg":"About_founderImg__QYaIk","midBlock":"About_midBlock__yfrHi"};